import axios from "axios";

export const getPostsRequests = async () =>
  await axios.get("https://mern-backend.fly.dev/posts/");

export const createPostRequest = async (post) => {
  const form = new FormData();

  for (let key in post) {
    form.append(key, post[key]);
  }

  return await axios.post("https://mern-backend.fly.dev/posts/", form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deletePostRequest = async (_id) =>
  await axios.delete("https://mern-backend.fly.dev/posts/" + _id);

export const getPostRequest = async (_id) =>
  await axios.get("https://mern-backend.fly.dev/posts/" + _id);

export const updatePostRequest = async (_id, newFields) =>
  await axios.put(`https://mern-backend.fly.dev/posts/${_id}`, newFields);
